module.exports = __webpack_public_path__ + "static/img/icon_home.a199919a.jpg";